<template>
    <div class="infor fl">
        <all-header
            :label="lable"
            :ischage="ischage"
            :sublabel="sublabel"
            :subtitle="subtitle"
            @getvalue="getvalue"></all-header>
        <div v-if="list && step > 0" class="stepContainer">
            <div v-for="(item, index) in list" :key="index">
                <div class="stepcone">
                    <div
                        v-if="(index <= list.length - 1 ) "
                        class="line"
                        :style="{ width: (10 - list.length) * 48 + '%' }"></div>
                    <div
                        class="stepItem"
                        :class="{
                            isactibe: item.success,
                            stponce: step == index,
                            error: isFail == 'fail' && step == 3 && index == step,
                        }">
                        <i
                            v-if="index + 1 < list.length && step != index"
                            class="el-icon-check"
                            style="color: white"></i>
                        <span v-if="index + 1 < list.length && step == index">{{
                            index + 1
                        }}</span>
                        <img
                            v-if="step != 3 && index + 1 == list.length"
                            src="../assets/np18.png">
                        <img
                            v-if="step == 3 && index + 1 == list.length"
                            src="../assets/18.png">
                        <img
                            v-if="step == index"
                            src="../assets/down.png"
                            alt
                            class="downpng">
                    </div>

                    <span
                        v-if="isFail == 'fail' && step == 3 && index == step"
                        class="erroritem stepTitle">审核不通过</span>
                    <span
                        v-else
                        class="stepTitle"
                        :class="{
                            successtitle: item.success,
                            stpotitle: step == index,
                            erroritem: item.error,
                        }">{{ item.title }}</span>
                </div>
            </div>


        </div>
         
        <div v-if="step == -1" class="block-list">
            <div
                v-for="(item, index) in projectList"
                :key="index"
                class="block-list-item">
                <div class="block-list-item-r-t">
                    {{item.level}}
                </div>
                <div class="block-list-item-box">
                    <div class="block-list-item-box-t">
                        {{ item.title }}
                    </div>
                    <div class="block-list-item-box-startend">
                        共{{ item.count }}条记录
                    </div>
                </div>
                <div
                    class="block-list-item-box-b"
                    @click="projectrecordList(1,item.id,item.title)">
                    申报记录
                </div>
            </div>
        </div>
        <div v-if="step == -2" ref="pdf">
            <div>
                <el-table
                    :data="recordlist"
                    :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
                    style="width: 100%; margin-top: 30px">
                    <el-table-column :show-overflow-tooltip="true" prop="eproject_batch.year" label="申报年份" min-width="80">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="name" label="申报人" show-overflow-tooltip min-width="160">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" label="工作类型" min-width="100">
                         <template slot-scope="scope">
                            <span>{{ scope.row.major_type}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" label="申报专业" min-width="100">
                         <template slot-scope="scope">
                            <span>{{ scope.row.application_major}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" label="申请工作范围	" min-width="120">
                         <template slot-scope="scope">
                            <span>{{ scope.row.work_jobs}}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column :show-overflow-tooltip="true" prop="created_at" label="申报时间" min-width="150">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" min-width="100" prop="statustext" label="审核状态">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        prop="operation"
                        width="70px"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                @click="
                                    detail(scope.row.id, scope.row.status, scope.row.eproject.title,scope.row.file_urls,scope.row)
                                ">
                                {{ scope.row.operation }}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagetion
                    :total="total"
                    class="pos-page"
                    @getpageValue="getpageValue"></pagetion>
            </div>
           
        </div>
        <div v-if="step == 0">
            <lineconbgtir :labelcontainer="labelcontainertow"></lineconbgtir>
            <!--<div class="infor-c">-->
            <!--    中天城投集团是全省唯一一家房地产上市公司，中天城投集团是贵州省两个具有壹级开发资质的企业之一，无论土地资源储备、开发规模、资金实力，还是企业影响力、治理结构、管理基础，始终保持贵州省内房地产行业龙头企业的地位，是贵州省的房地产著名品牌。-->
            <!--    二十余年来，中天城投集团以超前的意识、敏锐的目光，通过所开发的四代住宅小区的示范效应，形成了在贵州具有广泛影响力的中天住宅品牌。成功开发中天花园、中天·世纪新城、中天会展城等项目，同时涵盖物业、健身、教育等产业，并且这些产业都是有口皆碑的。现在中天中天城投集团着重开发未来方舟这个超级大盘。中天城投集团是全省唯一一家房地产上市公司，中天城投集团是贵州省两个具有壹级开发资质的企业之一，无论土地资源储备、开发规模、资金实力，还是企业影响力、治理结构、管理基础，始终保持贵州省内房地产行业龙头企业的地位，是贵州省的房地产著名品牌。-->
            <!--    二十余年来，中天城投集团以超前的意识、敏锐的目光，通过所开发的四代住宅小区的示范效应，形成了在贵州具有广泛影响力的中天住宅品牌。成功开发中天花园、中天·世纪新城、中天会展城等项目，同时涵盖物业、健身、教育等产业，并且这些产业都是有口皆碑的。现在中天中天城投集团着重开发未来方舟这个超级大盘。-->
            <!--</div>-->

            <lineconbgtir :labelcontainer="Documentedit" class="margin-top-40"></lineconbgtir>
            <p style="margin-top: 40px; text-align: start">
                本项目为线上申报，请点击下方按钮进入申报表单填报页面
            </p>
            <downinpu v-if="faile" :downlist="downlist"></downinpu>
            <el-button
                icon="el-icon-edit"
                style="
          color: #194abe;
          border: 1px solid #194abe;
          width: 189px;
          height: 50px;
          font-size: 18px;
          margin-top: 50px;
        "
                size="small"
                :disabled="false"
                @click="onSubmitTap">
                开始填写资料
            </el-button>
        </div>
        <div v-if="step === 1">
            <div v-if="isFail =='pendding'" class="shenhjrkr">
                <img src="../assets/shenhr.png" alt>
                <p style="font-size: 16px; color: #333333">待平台初审中...</p>
                <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
                    正在审核您提交的资料，请稍后查看结果
                </p>
                <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="apply_view">
                            查看申请资料
                        </el-button>
                    </div>

            </div>
            <div v-if="isFail =='response'" class="shenhjrkr">
                <img src="../assets/shenhr.png" alt>
                <p style="font-size: 16px; color: #333333">待分配专家...</p>
                <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
                    正在审核您提交的资料，请稍后查看结果
                </p>
                <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="apply_view">
                            查看申请资料
                        </el-button>
                    </div>

            </div>
            <div v-if="isFail == 'fail'">
                <div class="shenhjrkr">
                    <img src="../assets/faile.png" alt>
                    <p style="font-size: 20px; color: #333333">审核未通过</p>
                    <p style="font-size: 16px; color: #e51725; margin: 10px 0">
                        未通过原因：{{ reason }}
                    </p>
                    <p style="font-size: 16px; color: #9fa5ae; margin: 10px 0">
                       请修改后重新提交
                    </p>
                    <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="now_modify">
                            现在去修改
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-if="step === 2">
            <div v-if="isFail =='pendding'" class="shenhjrkr">
                <img src="../assets/shenhr.png" alt>
                <p style="font-size: 16px; color: #333333">待专家审核中...</p>
                <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
                    正在审核您提交的资料，请稍后查看结果
                </p>
                <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="apply_view">
                            查看申请资料
                        </el-button>
                    </div>

            </div>
            <div v-if="isFail =='response'" class="shenhjrkr">
                <img src="../assets/shenhr.png" alt>
                <p style="font-size: 16px; color: #333333">待平台入库审核...</p>
                <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
                    正在审核您提交的资料，请稍后查看结果
                </p>
                <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="apply_view">
                            查看申请资料
                        </el-button>
                    </div>

            </div>
        </div>


        <div v-if="step === 3">
            <div v-if="isFail == 'pendding'" class="shenhjrkr">
                <img src="../assets/shenhr.png" alt>
                <p style="font-size: 16px; color: #333333">待平台入库审核中</p>
                <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
                    正在审核您提交的资料，请稍后查看结果
                </p>
                <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="apply_view">
                            查看申请资料
                        </el-button>
                    </div>

            </div>
            <div v-if="isFail == 'fail'">
                <div class="shenhjrkr">
                    <img src="../assets/faile.png" alt>
                    <p style="font-size: 20px; color: #333333">入库审核失败</p>
                    <p style="font-size: 16px; color: #e51725; margin: 10px 0">
                        未通过原因：{{ reason }}
                    </p>
                </div>
            </div>
            <div v-if="isFail == 'response'" class="shenhjrkr">
                <img src="../assets/failesucee.png" alt>
                <p style="font-size: 20px;color:#333333">已入库</p>
                
            </div>
        </div>
        <div v-if="step == 4">

            <div v-if=" isFail == 'response'">
                <div class="shenhjrkr">
                    <img src="../assets/failesucee.png" alt>
                    <p style="font-size: 20px; color: #333333">入库成功</p>
                </div>
            </div>
            <div v-else>
                <div class="shenhjrkr">
                    <img src="../assets/faile.png" alt>
                    <p style="font-size: 20px; color: #333333">入库不成功</p>
                    <p style="font-size: 16px; color: #e51725; margin: 10px 0">
                        未成功原因：{{ reason }}
                    </p>
                </div>
            </div>
        </div>
        <erpojectpreview
            v-if="isdownload"
            :alldata="content"
            @previewDom="previewDom"></erpojectpreview>
    </div>
</template>

<script>
import erpojectpreview from '@/components/word/preview_eproject.vue'
import Lineconbgtir from './Modal/Line'
import Downinpu from '@/components/Modal/Downinpu'
import Pagetion from '@/components/Modal/Pagetion'
import AllHeader from '@/components/Modal/AllHeader'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import FromProject from './fromProjcet/greenProject.vue'
import {
    EprojectInfoList,
    EprojectDeclareDetails,
    EprojectDeclareDestory,
    EprojectList,
    EprojectInfo, //申报记录详情
    EprojectLog, //申报奖项
    EprojectListWithCount
} from '../utils/api.js'
export default {
    name: 'EdeclarRecord',
    components: {
        AllHeader,
        Pagetion,
        // Steps,
        Lineconbgtir,
        Downinpu,
        erpojectpreview,
        FromProject
    },
    data() {
        return {
            dialogUploadVisible:false,
            projectname:'',//项目名称
            isfile_urls:null,//利用file_urls判断绿色施工是否第二次上传资料
            content: {},//表单数据
            isdownload: false,//需要下载得页面是否显示
            total: 1,
            sublabel: '返回记录列表',
            subtitle: '',
            ischage: '',
            lable: '',
            recordlist: [],
            list: [
                {
                    title: '选择项目',
                    isred: true
                },
                {
                    title: '资料上传',
                    isred: true
                },
                {
                    title: '平台审核',
                    isred: true
                },
                {
                    title: '专家审核',
                    isred: true
                },
                {
                    title: '完成',
                    isred: true
                }
            ],
            projectList: [], //奖项列表
            address: '', //收货地址
            reason: '', //审核未通过原因
            file_urls: [],
            modifyID: '',//奖项id
            showErr: false,
            isFail: 'pending', //审核状态是否失败 fail(失败) pending(审核中) response(成功)
            id: '',
            token: '',
            pageSize: 10,
            step: -1,
            rstep:-1,
            fileList: [],
            filesupplementList:[],
            textarea: '',
            labelcontainertow: {
                lable: '申请须知',
                desc: 'Application Notes'
            },
            Documentedit: {
                lable: '填写申请表单',
                desc: 'Document edit'
            },
            labelcontainerdeclare: {
                lable: '请选择您要申报的项目',
                desc: ''
            },
            labelcontainer: {
                lable: '开始上传',
                desc: 'Document download'
            },
            labelcontaineragain: {
                lable: '上传附件',
                desc: 'Upload the completed form'
            },
            labelcontainerdow: {
                lable: '申请文档下载',
                desc: 'Document download'
            },
            supplementName:'',//补充材料名词
            currentSupplementId:0,
            currentId:0,
            currentSubTitle:'',
            activeProject: {},
            is_show_score:0,
            projectid:0
        }
    },
    computed: {
    },
    mounted() {
        this.lable = this.$route.query.name
        this.token = 'Bearer ' + localStorage.getItem('TOKEN')
        this.initList(1)
    },
    methods: {
        //下载PDF
        getPdf(ref) {
            let _this = this
            html2Canvas(ref, {
                allowTaint: true,
                useCORS: true
            }).then(function (canvas) {
                console.log(999, canvas)
                // const width = ref.offsetWidth
                // const height = ref.offsetHeight
                var context = canvas.getContext('2d')
                context.mozImageSmoothingEnabled = false
                context.webkitImageSmoothimgEnabled = false
                context.msImageSmoothingEnabled = false
                context.imageSmoothingEnabled = false
                let contentWidth = canvas.width
                let contentHeight = canvas.height
                let pageHeight = contentWidth / 592.28 * 841.89
                let leftHeight = contentHeight
                let position = 0
                let imgWidth = 595.28
                let imgHeight = 592.28 / contentWidth * contentHeight
                let pageData = canvas.toDataURL('image/jpeg/png/jpg', 1.0)
                let PDF = new JsPDF('', 'pt', 'a4')
                if (leftHeight < pageHeight) {
                    PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
                } else {
                    while (leftHeight > 0) {
                        PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                        leftHeight -= pageHeight
                        position -= 841.89
                        if (leftHeight > 0) {
                            PDF.addPage()
                        }
                    }
                }
                PDF.save(_this.subtitle + '.pdf')
                _this.isdownload = false
            })
        },
        previewDom(v) {
            this.getPdf(v)
        },
        downfile() {
            this.isdownload = true
        },
        detail(id, status, title, file_urls,content) {
            this.projectid = id;
            this.onApplyTap(id, status, title)
        },
        edit(id,created_at){
            this.$router.push('/form?title=省级施工工法&id=12&a_id='+id)
        },
        destory(id){
            DeclareDestory(id).then((res) => {
                this.$message.success('删除成功')
                this.projectrecordList(1)
            }).catch(err => {
                console.log(err)
                this.$message.error(err)
            })
        },
        //申报奖项记录列表
        async projectrecordList(page,project_id,title){
            if(project_id){
                this.currentId = project_id
                this.currentSubTitle = title
            }
            const data = {
                page_size: this.pageSize,
                page: page,
                project_id:this.currentId
            }
            this.lable = this.$route.query.name
            let res = await EprojectInfoList(data)
            console.log(987, res)
            this.step = -2
            this.ischage = true
            this.subtitle = this.currentSubTitle
            this.total = res.total
            res.data.forEach((element) => {
                element.created_at = element.created_at.replace(/\s[\x00-\xff]*/g, '')
                element.year = element.created_at.substring(0,4)
                //状态:1:初审通过,待分配专家,2:已分配专家,待专家审核,3:专家已全部审核,待平台审核,4:已入库,5:初审不通过 6:入库不通过	
                if (element.status == 0) {
                    element.statustext = '待平台初审'
                    element.operation = '详情'
                }
                if (element.status == 1) {
                    element.statustext = '待分配专家'
                    element.operation = '详情'
                }
                if (element.status == 2) {
                    element.statustext = '待专家审核'
                    element.operation = '详情'
                }
                if (element.status == 3) {
                    element.statustext = '待平台终审'
                    element.operation = '详情'
                }
                if (element.status == 4) {
                    element.statustext = '已入库'
                    element.operation = '详情'
                }
                if (element.status == 5) {
                    element.statustext = '审核不通过'
                    element.operation = '详情'
                }
                if (element.status == 6) {
                    element.statustext = '入库不通过'
                    element.operation = '详情'
                }
            })
            this.recordlist = res.data
        },
        //奖项列表
        async initList(page) {
            const data = {
                page_size: this.pageSize,
                page: page
            }
            let res = await EprojectListWithCount(data)
            this.projectList = res.data || []
        },
        async projectExport(){
            let url = `${window.location.protocol}//${window.location.host}/api/home/user/eproject_log/export/${this.activeProject.id}?token=${this.token}`;
             console.log(url)
             window.open(url);
        },
        // 去申请查看申请信息
        async onApplyTap(id, status, title) {
            if (status) {
                

                EprojectDeclareDetails(id)
                    .then((res) => {
                        this.activeProject = res
                        console.log('this.activeProject',this.activeProject)
                        this.content = res
                        
                        this.list= [
                                {
                                    title: '资料上传',
                                    isred: true
                                },
                                {
                                    title: '平台初审',
                                    isred: true
                                },
                                {
                                    title: '专家评审',
                                    isred: true
                                },
                                {
                                    title: '平台入库',
                                    isred: true
                                }
                            ];
                            this.id = res.id
                            this.modifyID = res.id
                            if (res.status == 5) {
                                //审核不通过
                                this.step = 1
                                this.rstep = 1
                                this.isFail = 'fail'
                                this.reason = res.reject_reason || ''
                            }
                            if (res.status == 6) {
                                //审核不通过
                                this.step = 3
                                this.rstep = 1
                                this.isFail = 'fail'
                                this.reason = res.reject_reason || ''
                            }
                            if (res.status == 4) {
                                //审核通过
                                this.step = 3
                                this.rstep = 1
                                this.isFail = 'response'
                            }
                                            //状态:1:初审通过,待分配专家,2:已分配专家,待专家审核,3:专家已全部审核,待平台审核,4:已入库,5:初审不通过 6:入库不通过	

                            if (res.status == 3) {
                                //待平台审核
                                this.step = 3
                                this.rstep = 1
                                this.isFail = 'pendding'
                            }
                            if (res.status == 2) {
                                //待专家审核
                                this.step = 2
                                this.rstep = 2
                                this.isFail = 'pendding'
                            }
                            if (res.status == 1) {
                                //待分配专家
                                this.step = 1
                                this.rstep = 1
                                this.isFail = 'pendding'
                            }
                            
                        this.ischage = true
                        this.subtitle = title
                    })
                    .catch((err) => {
                        this.$message.error(err)
                    })
            }
        },
        handleAdd(response, file, fileList) {
            this.setUrls(fileList)
        },
        handleRemove(file, fileList) {
            this.setUrls(fileList)
        },
        handlePreview(file) {
        },
        
        //获取上传数组
        setUrls(fileList) {
            let urls = []
            fileList.map((item) => {
                urls.push(item.response.data.host + item.response.data.url)
            })
            this.file_urls = urls
            console.log(this.file_urls)
        },
        handleError(err, file, fileList) {
            this.showErr = true
            let that = this
            setTimeout(function () {
                that.showErr = false
                console.log(that.showErr)
            }, 2000)
            // console.log(this.showErr);
        },
        //现在去修改
        now_modify() {
            console.log('`/epform?title=${this.subtitle}&id=${this.modifyID}&r=${this.id}&project_batch_id=${this.activeProject.project_batch_id}`',`/epform?title=${this.subtitle}&id=${this.modifyID}&r=${this.id}&project_batch_id=${this.activeProject.project_batch_id}`)
            this.$router.push(`/epform?title=${this.subtitle}&id=${this.activeProject.project_id}&r=${this.id}&project_batch_id=${this.activeProject.project_batch_id}`)
        },
        apply_view(){
            this.$router.push(`/word_eproject?id=${this.id}&projectid=${this.modifyID}&projectbatchid=${this.activeProject.project_batch_id}&title=${this.subtitle}&is_view=1`);
        },
        getvalue() {
            console.log(this.step)
            if(this.step==-2){
                this.step = -1
                this.ischage = false
                this.subtitle = ''
            }
            else{
                this.step = 0
            }
        },

        getpageValue(index) {
            // console.log(index);
            // this.initList(index);
            this.projectrecordList(index)
        },
        greenPorject(v,is){
            console.log(v,is)
        },
        handleClose(done){
            this.supplementName = ''
            this.filesupplementList = []
            done()
        },
        supplementClose(){
            this.dialogUploadVisible = false
            this.supplementName = ''
            this.filesupplementList = []
        }
    }
}
</script>

<style>
.el-table .cell {
  width: max-content;
}
</style>
<style lang="less" scoped>
.applybut {
  padding: 6px 15px;
}
/deep/.block-title {
  border-left: 3px solid #194abe !important;
}
/deep/.el-upload-list{
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  text-align: start;
  height: auto;
}

.textarea {
  width: 382px;
  // height: 92px;
  background: #ffffff;
  border: 1px solid #bdc3cb;
  opacity: 1;
  border-radius: 4px;
}

.block-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0;

  &-item {
    width: 370px;
    background: #ffffff;
    border: 1px dashed #c8cdd5;
    padding: 24px 25px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 21px;
    position: relative;
    &-r-t {
      position: absolute;
      top: 0;
      right: 0;
      width: 73px;
      height: 27px;
      background: #f5f9fb;
      opacity: 1;
      border-radius: 0px 0px 0px 80px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 27px;
      color: #c6c9ce;
      padding-left: 10px;
      box-sizing: border-box;
    }
    &-box {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      &-t {
        width: 244px;
        color: #0c0d0f;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align: justify;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      &-dtae {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 26px;
        color: #194abe;
      }
      &-startend {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
          margin-top:10px;
      }
      &-b {
        width: 91px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #194abe;
        color: #194abe;
        opacity: 1;
        border-radius: 6px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }

      &-b-d {
        background: #ffffff !important;
        border: 1px solid #d4dbdd !important;
        color: #c8cdd5 !important;
      }

      &-b-s {
        background: #d4dbdd !important;
        border: 1px solid #d4dbdd !important;
        color: #ffffff !important;
      }
    }
  }
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.infor {
  padding-bottom: 40px;
  min-height: 800px;
  margin-bottom: 34px;
  position: relative;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.upload-demo2{
    justify-content: flex-start;
    align-items: flex-start;
    width:480px;
}
.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.margin-top-40 {
  margin-top: 40px;
}

.block-solid {
  width: 100%;
  height: 2px;
  background-color: #e51725;
  margin-top: 30px;
}

.shenhjrkr {
  margin: 71px 0 100px 0;

  img {
    width: 120px;
  }
}

.stepContainer {
  width: 100%;
  height: 160px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  .stepcone {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stepItem {
      width: 50px;
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #9fa5ae;
      border: 1px solid #9fa5ae;
      font-size: 32px;
      font-weight: 900;
      color: #c8cdd5;
      z-index: 999;

      .downpng {
        position: absolute;
        top: -20px;
        width: 20px;
        height: auto;
      }
    }

    img {
      width: 27px;
      height: auto;
    }

    .isactibe {
      color: white;
      // border: 1px solid #9FA5AE;
      // background-color: #9FA5AE;
    }

    .stponce {
      color: #194abe;
      border: 1px solid #194abe;
      background-color: white;
    }

    .error {
      color: #e51725;
      border: 1px solid #e51725;
      background-color: white;
    }

    .stepTitle {
      font-size: 18px;
      color: #c8cdd5;
      margin-top: 10px;
    }

    .successtitle {
      color: #0c0d0f;
    }

    .stpotitle {
      color: #194abe;
    }

    .erroritem {
      color: #e51725;
    }

    .line {
      width: 350%;
      flex: 1;
      flex-shrink: 0;
      height: 2px;
      border-bottom: 1px dashed #d4dbdd;
      position: absolute;
      top: 25px;
      left: 85%;
    }
  }
}
.block-addr {
  display: inline-block;
  padding: 13px 32px;
  background-color: #fff7e8;
  font-size: 14px;
  margin-top: 31px;
  .span-l {
    color: #9fa5ae;
  }
  .span-r {
    color: #194abe;
  }
}
.form_1 .form_box_content .form_title{
    box-sizing: border-box;
    text-align: start;
    display: flex;
    align-items: center;
}
.my_form2, .my_form{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: visible;
    align-items: stretch;
}
.my_form2 .form_title,  .my_form .form_title{
    background: #eaf0f6;
    width: 129px;
    min-width: 129px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    padding: 6px;
    box-sizing: border-box;
    color: #0c0d0f;
}
.my_form2 .form_long,.my_form .form_long{
    width: 700px;
    padding: 0 6px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.my_form2 .form_long input, .my_form .form_long input{
    width: 488px;
    height: 36px;
    background: #fff;
    border: 1px solid #bdc3cb;
    opacity: 1;
    border-radius: 4px;
    padding: 0 15px;
    box-sizing: border-box;
}
.my_form2 .form_title {
    background: #f5f8fb;
}
.my_form2 .form_long{
    background: #fbfdff;
}

</style>

